import { Controller, useController } from "react-hook-form";

import RawAsyncSelectField from "./raw-async-select";
import { useRef } from "react";

const AsyncSelectField = (props) => {
    
    const {
        control,
        errors,
        name,
        id
    } = props;
    const {
        field: { onChange, value, onBlur }
    } = useController({
        name,
        control
    });
    const message = errors && (errors[name]?.message || errors[id]?.message);
    const isInvalid = errors && (errors[name] || errors[id]) && true;
    const selectRef = useRef();
    
    return (
        <Controller
            name={name}
            control={control}
            render={() => {
                return (
                    <RawAsyncSelectField
                        onChange={onChange}
                        value={value}
                        selectRef={selectRef}
                        {...props}
                        message={message}
                        isInvalid={isInvalid}
                        onBlur={onBlur}/>
                );
            }}/>
    );
};

export default AsyncSelectField;
